module.exports = __webpack_public_path__ + "static/media/nTopUpIcon.f3bb3703.svg";